import { isAuthenticated } from "../auth";
import { roleUser } from "../pageInside/roleUser";
import jsSHA from "jssha";
import { elakayAutoText } from "./dataElakay";
import { resolveBankAccountModalPageKey, getBankAccountModalVisibility } from "../../utils/bankAccountModalStatus";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["rolle"]?.[key] || fallback;

var sha1 = require('sha1');

// ---------------------------------------------------------------------------
// Switch Role / View As Role -- an OPTIONAL, request-scoped view overlay on
// top of everything above. NEVER modifies userActiveRole -- see
// Routes.js/roleSwitchFetch.js for how selectedRole is threaded through and
// sent to the backend, which is the only place that actually enforces it;
// this module is purely the frontend's own "act as if" mirror for UI/menu/
// route-guard purposes.
//
// "RUN ELAKAY AS THIS ROLE": selecting a role activates that role's own
// capabilities PLUS the roles it inherits (ROLE_INHERITANCE below) -- exactly
// what a real account of that role would have. Seller and Provider are two
// distinct branches: neither inherits the other; Associate and above inherit
// both. The numeric hierarchy (ROLE_CAPACITY_CONFIG / server_elakay/
// elakay_services/roleSwitchContext.js's LEVEL_BY_ROLE) governs a different
// question -- which roles this account may SELECT (getAllowedSwitchRoles/
// canSwitchRole). Investor VIP is not a Switch Role and is never granted here.

let __selectedRoleOverride = null;
let __allowedSwitchRoles = null;

// Called from Routes.js's readUser() every time a fresh /readMe response
// comes back (real role load, or a revalidated/reset selectedRole). Passing
// null clears the override -- this is exactly what "Return to Default" does.
export const setSelectedRoleOverride = (roleName, allowed) => {
  __selectedRoleOverride = roleName || null;
  __allowedSwitchRoles = allowed || null;
};
export const getSelectedRoleOverride = () => __selectedRoleOverride;
export const getAllowedSwitchRolesClient = () => __allowedSwitchRoles;

// Central, explicit source of truth for the three concepts Switch Role
// revolves around -- prefer this over re-deriving any of them ad hoc:
//   realRole      -- the account's true role (infoSource.realRole, sourced
//                     server-side from roleSwitch.realRole; never affected
//                     by an active switch).
//   selectedRole  -- the role currently chosen in RoleSwitchDropdown, or
//                     null for Default.
//   effectiveRole -- selectedRole || realRole: what the platform should
//                     currently behave as. Every Rolle.js hash-chain
//                     function (Family/Seller/Provider/etc.) and
//                     getCurrentElakayRole() already implement this exact
//                     rule internally via the override singleton above --
//                     this helper exists for any NEW call site that wants
//                     the three values explicitly instead of calling one of
//                     those per-role functions.
export const getRoleContext = (infoSource) => {
  const realRole = infoSource?.realRole || null;
  const selectedRole = infoSource?.selectedRole || null;
  return {
    realRole,
    selectedRole,
    effectiveRole: selectedRole || realRole,
    isRoleSwitchActive: !!selectedRole,
    allowedSwitchRoles: infoSource?.allowedSwitchRoles || [],
  };
};

// True only for a real account at/above the minimum Switch Role level
// (Associate..Family) -- backend's getAllowedSwitchRoles() (elakay_services/
// roleSwitchContext.js) returns an EMPTY array for every account below that
// (Seller/Provider/Royalty/User), so a plain length check here is exactly
// equivalent to "is this account's real role Associate or above". Use this
// to gate a section's own TITLE/heading wherever RoleSwitchDropdown is
// rendered (Header, footer, User Settings, drawer) -- the dropdown itself
// already renders nothing when unavailable, but a heading placed next to it
// in the page's own markup does not know that on its own and must be gated
// the same way, or a Seller/Provider/Royalty/User account sees an empty
// "Switch Role" heading with nothing under it.
export const isSwitchRoleAvailable = (infoSource) => (infoSource?.allowedSwitchRoles?.length || 0) > 0;

// Cumulative inheritance of every selectable role (canonical names, the ones
// the hash-chain functions below check). Seller and Provider are siblings:
// Seller never carries Provider privileges and vice versa. Mirrors the
// backend's roleSwitchContext.js ROLE_INHERITANCE.
export const ROLE_INHERITANCE = Object.freeze({
  User: Object.freeze([]),
  Royalty: Object.freeze(["Royalty"]),
  Seller: Object.freeze(["Seller", "Royalty"]),
  Provider: Object.freeze(["Provider", "Royalty"]),
  Associate: Object.freeze(["Associate", "Provider", "Seller", "Royalty"]),
  Investment: Object.freeze(["Investment", "Associate", "Provider", "Seller", "Royalty"]),
  Administrator: Object.freeze(["Administrator", "Investment", "Associate", "Provider", "Seller", "Royalty"]),
  Family: Object.freeze(["Family", "Administrator", "Investment", "Associate", "Provider", "Seller", "Royalty"]),
});

// Roles granted by a (selected) role name; unknown -> [].
export const getInheritedRoles = (roleName) => ROLE_INHERITANCE[normalizeWallRole(roleName)] || [];

// Returns null when no override is active -- callers (the hash-chain
// functions below) fall through to their original, unchanged logic in that
// case, which is exactly what makes selectedRole=null byte-identical to
// today's behavior. When an override IS active: `exact` (the functions' `ch`
// argument: "this very role, not a higher one", used by role badges) only
// matches the selected role itself; otherwise Royalty (the Buyer/navigation
// base) is always granted and any other role is granted when the selected
// role inherits it.
const isGrantedUnderOverride = (checkRoleName, exact = false) => {
  const sel = __selectedRoleOverride;
  if (!sel) return null;
  const selected = normalizeWallRole(sel) || sel;
  if (exact) return checkRoleName === selected;
  if (checkRoleName === "Royalty") return true;
  return getInheritedRoles(selected).includes(checkRoleName);
};

export const Family =(user)=> {
    const overridden = isGrantedUnderOverride("Family");
    if (overridden !== null) return overridden;
    const { a, b, e, token } = isAuthenticated();
    let Familykay
    let FamilyshaObj
    let Familyrole
if (e === roleUser[0].email ){
    return true
}
if(token){
    if(a){
        Familykay = sha1(roleUser[0].code) + sha1(roleUser[0].role) + sha1(a)
    FamilyshaObj = new jsSHA("SHA-512", "TEXT", {
    hmacKey: { value: Familykay, format: "TEXT" }
        });
    FamilyshaObj.update(Familykay);
    Familyrole = FamilyshaObj.getHash("HEX")
    if (Familyrole === b){
       return  true
    } else {
        if (user === roleUser[0].email) {
            return true
        }else{
        return false
        }
    }
} return false
}
   
}

export const Adminstrator= (ch = false) => {
    const overridden = isGrantedUnderOverride("Administrator", ch);
    if (overridden !== null) return overridden;
    const { a, b, token } = isAuthenticated();
    if (token && a) {
        const Adminkay = sha1(roleUser[1].code) + sha1(roleUser[1].role) + sha1(a)
        const AdminshaObj = new jsSHA("SHA-512", "TEXT", {
            hmacKey: { value: Adminkay, format: "TEXT" },
        });
        AdminshaObj.update(Adminkay);
        const Adminrole = AdminshaObj.getHash("HEX");
        if (Adminrole === b) {
            return true
        }
    }
    if (Family()) {
        return !ch ? true : false
    }
    return false
}

export const Investment = (ch = false) => {
    const overridden = isGrantedUnderOverride("Investment", ch);
    if (overridden !== null) return overridden;
    const { a, b, token } = isAuthenticated();
    if (token && a) {
        const Providerkay = sha1(roleUser[7].code) + sha1(roleUser[7].role) + sha1(a)
        const ProvidershaObj = new jsSHA("SHA-512", "TEXT", {
            hmacKey: { value: Providerkay, format: "TEXT" },
        });
        ProvidershaObj.update(Providerkay);
        const Providerrole = ProvidershaObj.getHash("HEX");
        if (Providerrole === b) {
            return true
        }
    }
    if (Adminstrator()) {
        return !ch ? true : false
    }
    return false
}

export const Assoociate = (ch = false) => {
    const overridden = isGrantedUnderOverride("Associate", ch);
    if (overridden !== null) return overridden;
    const { a, b, token } = isAuthenticated();
    if (token && a) {
        const Providerkay = sha1(roleUser[6].code) + sha1(roleUser[6].role) + sha1(a)
        const ProvidershaObj = new jsSHA("SHA-512", "TEXT", {
            hmacKey: { value: Providerkay, format: "TEXT" },
        });
        ProvidershaObj.update(Providerkay);
        const Providerrole = ProvidershaObj.getHash("HEX");
        if (Providerrole === b) {
            return true
        }
    }
    if (Investment()) {
        return !ch ? true : false
    }
    return false
}

export const Provider = (ch = false) => {
    const overridden = isGrantedUnderOverride("Provider", ch);
    if (overridden !== null) return overridden;
    const { a, b, token } = isAuthenticated();
    if (token && a) {
        const Providerkay = sha1(roleUser[3].code) + sha1(roleUser[3].role) + sha1(a)
        const ProvidershaObj = new jsSHA("SHA-512", "TEXT", {
            hmacKey: { value: Providerkay, format: "TEXT" },
        });
        ProvidershaObj.update(Providerkay);
        const Providerrole = ProvidershaObj.getHash("HEX");
        if (Providerrole === b) {
            return true
        }
    }
    if (Assoociate()) {
        return !ch ? true : false
    }
    return false
}

export const Seller = (ch = false) => {
    const overridden = isGrantedUnderOverride("Seller", ch);
    if (overridden !== null) return overridden;
    const { a, b, token } = isAuthenticated();
    if (token && a) {
        const Sellerkay = sha1(roleUser[4].code) + sha1(roleUser[4].role) + sha1(a)
        const SellershaObj = new jsSHA("SHA-512", "TEXT", {
            hmacKey: { value: Sellerkay, format: "TEXT" },
        });
        SellershaObj.update(Sellerkay);
        const Sellerrole = SellershaObj.getHash("HEX");
        if (Sellerrole === b) {
            return true
        }
    }
    // Seller and Provider are sibling branches: a Provider is never a Seller.
    if (Assoociate()) {
        return !ch ? true : false
    }
    return false
}

// Any commercial role (Seller OR Provider branch, or above): for features
// both branches legitimately share (wallet/banking, shop name, income...).
export const CommercialRole = () => Boolean(Seller() || Provider());


export const Customer = (ch = false) => {
    // Customer() is the codebase's existing name for the Royalty tier (its
    // hash check below uses roleUser[5], the "Royalty" entry).
    const overridden = isGrantedUnderOverride("Royalty", ch);
    if (overridden !== null) return overridden;
    const { a, b, token } = isAuthenticated();
    if (token && a) {
        const Customerkay = sha1(roleUser[5].code) + sha1(roleUser[5].role) + sha1(a)
        const CustomershaObj = new jsSHA("SHA-512", "TEXT", {
                hmacKey: { value: Customerkay, format: "TEXT" },
        });
        CustomershaObj.update(Customerkay);
        const Customerrole = CustomershaObj.getHash("HEX");
        if (Customerrole === b) {
            return true
        }
    }
    if (Seller() || Provider()) {
        return !ch ? true : false
    }
    return false
}

// Hiérarchie de visibilité du Seller Center. Seller et Provider partagent le
// même niveau : sélectionner l'un ou l'autre autorise tous les rôles métier.
export const DROPSHIPPING_VISIBILITY_ROLES = [
  { value: "Family", get label() { return elakayAutoText("h_4efb6cb7c018f0", "Developer"); }, level: 5 },
  { value: "Admin", get label() { return elakayAutoText("h_4e7afebcfbae00", "Admin"); }, level: 4 },
  { value: "Investor", get label() { return elakayAutoText("h_e7190516d1891d", "Investor"); }, level: 3 },
  { value: "Associate", get label() { return elakayAutoText("h_5f1e87a5d1f90b", "Associate"); }, level: 2 },
  { value: "Seller", get label() { return elakayAutoText("h_ec3ef051d5a8bf", "Seller"); }, level: 1 },
  { value: "Provider", get label() { return elakayAutoText("h_7ceee3f3615a2b", "Provider"); }, level: 1 },
];

const DROPSHIPPING_ROLE_ALIASES = {
  family: "Family",
  familly: "Family",
  famille: "Family",
  admin: "Admin",
  administrator: "Admin",
  administrateur: "Admin",
  investor: "Investor",
  investment: "Investor",
  associate: "Associate",
  assoociate: "Associate",
  seller: "Seller",
  provider: "Provider",
  producer: "Provider",
};

export const normalizeDropshippingRole = (roleName) =>
  DROPSHIPPING_ROLE_ALIASES[String(roleName || "").trim().toLowerCase()] || null;

// Seller-side dropshipping (external platforms + Dropshipping In as a buyer)
// belongs to the Seller branch: an effective Provider never gets it, whatever
// minimum role Animation Settings sets (Provider keeps its own Provider-side
// internal dropshipping, gated by getCommercialCapabilities instead).
export const canRoleAccessDropshipping = (roleName, visibilitySettings = {}) => {
  if (visibilitySettings?.enabled === false) return false;
  const currentRole = normalizeDropshippingRole(roleName);
  const minimumRole = normalizeDropshippingRole(visibilitySettings?.minimumRole || "Seller") || "Seller";
  if (!currentRole || currentRole === "Provider") return false;

  const currentLevel = DROPSHIPPING_VISIBILITY_ROLES.find((role) => role.value === currentRole)?.level || 0;
  const minimumLevel = DROPSHIPPING_VISIBILITY_ROLES.find((role) => role.value === minimumRole)?.level || 1;
  return currentLevel >= minimumLevel;
};

export const getCurrentElakayRole = (infoSource) => {
  // Switch Role / View As Role: when an override is active, it IS the
  // current role for every purpose this function serves (Dropshipping
  // visibility, etc.) -- short-circuit before any of the normal resolution
  // below runs.
  if (getSelectedRoleOverride()) return normalizeDropshippingRole(getSelectedRoleOverride()) || getSelectedRoleOverride();
  if (infoSource?.selectedRole) return normalizeDropshippingRole(infoSource.selectedRole) || infoSource.selectedRole;
  const session = isAuthenticated();
  const declaredRole =
    infoSource?.userInfo?.userActiveRole?.roleName
    || infoSource?.userInfo?.roleName
    || session?.user?.userActiveRole?.roleName
    || session?.userActiveRole?.roleName;
  const normalizedDeclaredRole = normalizeDropshippingRole(declaredRole);
  if (declaredRole && !normalizedDeclaredRole) return normalizeWallRole(declaredRole);
  if (normalizedDeclaredRole) return normalizedDeclaredRole;

  // Fallback compatible avec les anciens tokens chiffrés utilisés par Rolle.
  if (Family(infoSource?.userInfo?.email)) return "Family";
  if (Adminstrator(true)) return "Admin";
  if (Investment(true)) return "Investor";
  if (Assoociate(true)) return "Associate";
  if (Provider(true)) return "Provider";
  if (Seller(true)) return "Seller";
  return null;
};

// ---------------------------------------------------------------------------
// Full Wall/role hierarchy (User -> Family). Used to cap "which Wall am I
// browsing/posting as" pickers to the current user's own rank and below.
// Kept separate from DROPSHIPPING_VISIBILITY_ROLES above (a narrower scale
// for the Seller Center feature-gate only) and from the `leve`-based arrays
// already used correctly in actPageAssUserExit.jsx / userAddingRoleByToken.jsx
// (left as-is) -- this is the shared source of truth for any *new*
// self-hierarchy picker such as the How We Do It role filter.
//
// Business rule: User / User Royal / Seller / Provider are "become this"
// growth tiers -- every visitor, regardless of their own rank (including
// logged-out), can always see them. Associate / Investment / Administrator /
// Family stay gated behind the ordinary cumulative hierarchy: only visible
// once the current user's own role has reached that tier.
export const WALL_ALWAYS_VISIBLE_ROLES = ["User", "Royalty", "Seller", "Provider"];
export const WALL_PROTECTED_ROLE_HIERARCHY = ["Associate", "Investment", "Administrator", "Family"];
export const WALL_ROLE_HIERARCHY = [...WALL_ALWAYS_VISIBLE_ROLES, ...WALL_PROTECTED_ROLE_HIERARCHY];

// Deliberately no "" -> "User" alias: an empty/missing role means "unknown",
// which must resolve like null/undefined (getVisibleWallRoles returns []),
// not silently grant the User tier.
const WALL_ROLE_ALIASES = {
  user: "User",
  royal: "Royalty",
  royalty: "Royalty",
  userroyal: "Royalty",
  user_royal: "Royalty",
  "user royal": "Royalty",
  "user royale": "Royalty",
  customer: "Royalty",
  seller: "Seller",
  provider: "Provider",
  producer: "Provider",
  associate: "Associate",
  assoociate: "Associate",
  investor: "Investment",
  investment: "Investment",
  administrator: "Administrator",
  admin: "Administrator",
  family: "Family",
  familly: "Family",
};

export const normalizeWallRole = (roleName) =>
  WALL_ROLE_ALIASES[String(roleName ?? "").trim().toLowerCase()] || null;

// Returns the canonical role names a user at `rawRoleName` is allowed to see
// in a self-hierarchy Wall/role picker: always User/Royalty/Seller/Provider,
// plus the protected tiers (Associate..Family) up to and including their own
// rank -- never higher. An unrecognized/missing role still gets the always-
// visible base tiers, but none of the protected ones (most restrictive for
// the part of the list that actually needs protecting).
export const getVisibleWallRoles = (rawRoleName) => {
  const normalized = normalizeWallRole(rawRoleName);
  const protectedIndex = WALL_PROTECTED_ROLE_HIERARCHY.indexOf(normalized);
  const visibleProtectedRoles = protectedIndex === -1
    ? []
    : WALL_PROTECTED_ROLE_HIERARCHY.slice(0, protectedIndex + 1);
  return [...WALL_ALWAYS_VISIBLE_ROLES, ...visibleProtectedRoles];
};

// Resolves the current logged-in user's raw role name the same way
// getCurrentElakayRole() does, but without narrowing it to the
// Dropshipping-only alias set -- needed by getVisibleWallRoles() above.
export const getCurrentWallRoleName = (infoSource) => {
  const session = isAuthenticated();
  return (
    infoSource?.userRole?.roleName
    || infoSource?.userInfo?.userActiveRole?.roleName
    || session?.user?.userActiveRole?.roleName
    || session?.userActiveRole?.roleName
    || null
  );
};

// Effective counterpart used by permission-sensitive navigation and filters.
// Keep getCurrentWallRoleName() above for financial/qualification flows that
// must intentionally inspect the real stored role (notably Investor VIP).
export const getEffectiveWallRoleName = (infoSource) => {
  const selected = getSelectedRoleOverride() || infoSource?.selectedRole;
  return normalizeWallRole(selected) || getCurrentWallRoleName(infoSource);
};

export const canViewDropshippingSellerCenter = (infoSource) =>
  canRoleAccessDropshipping(
    getCurrentElakayRole(infoSource),
    infoSource?.allSettings?.dropshippingVisibility
  );

export const canViewDropshippingPlatform = (infoSource, platformId) => {
  const visibility = infoSource?.allSettings?.dropshippingVisibility || {};
  if (!canViewDropshippingSellerCenter(infoSource)) return false;
  const platformVisibility = visibility?.platforms?.[platformId] || {};
  if (platformVisibility.enabled === false) return false;

  return canRoleAccessDropshipping(getCurrentElakayRole(infoSource), {
    enabled: true,
    minimumRole: platformVisibility.minimumRole || visibility.minimumRole || 'Seller',
  });
};

// Page x role driven now (Animation Settings' bankAccountModal section) --
// `infoSource` (this parameter used to be named `userInfo` but was never
// actually read by the body below; repurposed here, no real contract
// broken) is required to resolve BOTH the effective role (RoleSwitchDropdown-
// aware, via getCurrentElakayRole) and the loaded settings tree
// (infoSource.allSettings, already fetched once app-wide -- never triggers
// its own request). See utils/bankAccountModalStatus.js for the page
// resolver + visibility fallback chain (mirrored 1:1 from
// elakay_helpers/bankAccountModalStatus.js on the backend).
export const shouldShowBankAccountModal = (
  infoSource,
  location,
  hasBankAccount = false
) => {

  /* sécurité */
  if (!location || hasBankAccount) return false;

  const pathname = String(location.pathname || "").toLowerCase();
  const search = location.search || "";

  /* si déjà dans banking wallet */
  if (
    pathname === "/wallet" &&
    search === "?bkl=true"
  ) {
    return false;
  }

  const pageKey = resolveBankAccountModalPageKey(pathname);
  if (!pageKey) return false;

  const role = getCurrentElakayRole(infoSource);
  if (!role) return false;

  return getBankAccountModalVisibility(infoSource?.allSettings, pageKey, role);
};



export const getBankAccountMessage = (infoSource) => {
  __setElakayInfoSource(infoSource);

  if (Seller()) {

    return {

      title: __elakayText("t001", "Add your bank account"),

      message:

        __elakayText("t002", "If you are a seller, provider, or producer and you want to sell your products or services on Elakay, you must connect your bank account to receive your payments and income.")

    };

  }
if(Assoociate()){
  return {

    title: __elakayText("t001", "Add your bank account"),

    message:

      __elakayText("t003", "To receive commissions, revenue, or payments from Elakay sales, you must connect your bank account. Your eligible revenue will be sent by Stripe transfer after order delivery.")

  };
}
  // Always return content: the modal can still be open when the selected
  // Switch Role changes to one where neither Seller() nor Assoociate() holds.
  return {
    title: __elakayText("t001", "Add your bank account"),
    message: __elakayText("t003", "To receive commissions, revenue, or payments from Elakay sales, you must connect your bank account. Your eligible revenue will be sent by Stripe transfer after order delivery.")
  };
};

// Commercial capabilities. Seller and Provider stay siloed peers: a Provider
// is never a Seller (and vice versa), including under Switch Role. The
// Combined Sell Center is the ONLY place both sets are granted together, and
// only for the effective roles Associate -> Family (mirrors the backend's
// COMBINED_SELL_CENTER_ROLES). `role` here is the EFFECTIVE role
// (getCurrentElakayRole): selecting Seller/Provider in RoleSwitchDropdown
// narrows a combined account to that single mode; the real role in the DB is
// never touched. This is UX only -- the backend re-checks every write.
const COMBINED_ROLES = ["Associate", "Investor", "Admin", "Family"];
export const getCommercialCapabilitiesForRole = (roleName) => {
  const role = normalizeDropshippingRole(roleName);
  const seller = role === "Seller";
  const provider = role === "Provider";
  const combined = COMBINED_ROLES.includes(role);
  const asSeller = seller || combined;
  const asProvider = provider || combined;
  return {
    // Any commercial role (User Settings, account menus). NOT the Seller My Shop page itself.
    canAccessMyShop: Boolean(role),
    // Seller My Shop (/myShop) and Seller Product Edit (/product/edit/:id): the Seller workspace.
    // An effective Provider works from Provider Center instead (/provider, /provider/my-shop).
    canAccessSellerMyShop: asSeller,
    canEditSellerProducts: asSeller,
    canAccessSellerCenter: asSeller,
    canAccessProviderCenter: asProvider,
    canAccessCombinedSellCenter: combined,
    canCreateSellerProduct: asSeller,
    canImportProviderProduct: asSeller,
    canBrowseProviders: asSeller,
    canCreateProviderProduct: asProvider,
    canManageProviderProducts: asProvider,
    canManageWholesale: asProvider,
    canManageProviderDropshipping: asProvider,
    canManageProviderStorefront: asProvider,
  };
};
export const getCommercialCapabilities = (infoSource) =>
  getCommercialCapabilitiesForRole(getCurrentElakayRole(infoSource));
export const canAccessMyShop = (infoSource) => getCommercialCapabilities(infoSource).canAccessMyShop;
// Effective role is Provider only (no Seller workspace): Seller My Shop / Product Edit links are
// replaced by their Provider Center equivalents. A combined role (Associate -> Family) is never
// "provider only" unless it switched to Provider.
export const isProviderOnlyWorkspace = (infoSource) => {
  const caps = getCommercialCapabilities(infoSource);
  return caps.canAccessProviderCenter && !caps.canAccessSellerMyShop;
};
